// extracted by mini-css-extract-plugin
module.exports = {"scrollbox":"index_scrollbox_2L7jG"};